import React from 'react'
import Logo from '@/components/Logo'
import EditableText from '@/components/editable/EditableText'

const Footer: React.FC = () => {
  return (
    <footer className="relative bg-[#0E1B2C] border-t border-[rgba(232,220,196,0.08)]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <Logo size={56} />
              <div>
                <div className="text-[10px] tracking-luxe text-[#C9BFA8]"><EditableText contentKey="footer.brand.kicker" section="Footer" label="Sur-titre — Association" as="span">ASSOCIATION</EditableText></div>
                <div className="font-serif-display text-[22px] text-[#E8DCC4]"><EditableText contentKey="footer.brand.name" section="Footer" label="Nom de la marque" as="span">Centre de Transformation</EditableText></div>
              </div>
            </div>
            <p className="text-[14px] leading-[1.75] text-[#C9BFA8] max-w-md">
              <EditableText contentKey="footer.tagline" section="Footer" label="Tagline" multiline as="span">
                Un écosystème suisse vivant qui transforme, accueille, connecte et transmet — pour une génération en mouvement.
              </EditableText>
            </p>
          </div>

          {/* Sitemap */}
          <div className="lg:col-span-2">
            <EditableText as="div" contentKey="footer.explorer.titre" section="Footer" label="Explorer — titre colonne" className="text-[10px] tracking-luxe text-[#C8A24A] mb-4">
              EXPLORER
            </EditableText>
            <ul className="space-y-3 text-[13px] text-[#C9BFA8]">
              <li><a href="#vision" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.explorer.vision" section="Footer" label="Lien — Vision">Vision</EditableText></a></li>
              <li><a href="#piliers" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.explorer.piliers" section="Footer" label="Lien — Piliers">Piliers</EditableText></a></li>
              <li><a href="#poles" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.explorer.poles" section="Footer" label="Lien — Pôles">Pôles</EditableText></a></li>
              <li><a href="#publics" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.explorer.publics" section="Footer" label="Lien — Publics">Publics</EditableText></a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <EditableText as="div" contentKey="footer.simpliquer.titre" section="Footer" label="S'impliquer — titre colonne" className="text-[10px] tracking-luxe text-[#C8A24A] mb-4">
              S'IMPLIQUER
            </EditableText>
            <ul className="space-y-3 text-[13px] text-[#C9BFA8]">
              <li><a href="#partenaires" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.simpliquer.partenaires" section="Footer" label="Lien — Partenaires">Partenaires</EditableText></a></li>
              <li><a href="#contact" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.simpliquer.mecenat" section="Footer" label="Lien — Mécénat">Mécénat</EditableText></a></li>
              <li><a href="#contact" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.simpliquer.contact" section="Footer" label="Lien — Contact">Contact</EditableText></a></li>
              <li><a href="#contact" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.simpliquer.newsletter" section="Footer" label="Lien — Newsletter">Newsletter</EditableText></a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <EditableText as="div" contentKey="footer.contact.titre" section="Footer" label="Contact — titre colonne" className="text-[10px] tracking-luxe text-[#C8A24A] mb-4">
              CONTACT
            </EditableText>
            <a
              href="mailto:sylvie@associationcentredetransformation.ch"
              className="block text-[14px] text-[#E8DCC4] hover:text-[#C9E26A] mb-3"
            >
              sylvie@associationcentredetransformation.ch
            </a>
            <div className="text-[13px] text-[#C9BFA8]">
              <EditableText contentKey="footer.ancrage" section="Footer" label="Ancrage" as="span">
                Suisse · Genève · Gryon · Narbonne
              </EditableText>
            </div>
            <div className="flex items-center gap-2 mt-4 text-[11px] tracking-mid uppercase text-[#C9BFA8]">
              <span className="inline-block w-3 h-2 bg-[#D52B1E]" aria-hidden />
              <EditableText as="span" contentKey="footer.projetsuisse" section="Footer" label="Étiquette — Projet Suisse">Projet Suisse</EditableText>
            </div>
          </div>
        </div>

        <div className="divider-gold mb-8" />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-[11px] text-[#C9BFA8]/70">
            © {new Date().getFullYear()} <EditableText as="span" contentKey="footer.copyright" section="Footer" label="Mention copyright">Association Centre de Transformation. Tous droits réservés.</EditableText>
          </div>
          <div className="flex items-center gap-6 text-[11px] tracking-mid uppercase text-[#C9BFA8]/70">
            <a href="#" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.legal.mentions" section="Footer" label="Lien légal — Mentions légales">Mentions légales</EditableText></a>
            <a href="#" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.legal.confidentialite" section="Footer" label="Lien légal — Confidentialité">Confidentialité</EditableText></a>
            <a href="#" className="hover:text-[#C9E26A]"><EditableText as="span" contentKey="footer.legal.statuts" section="Footer" label="Lien légal — Statuts">Statuts</EditableText></a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
